import {
  dispatch,
  syncError,
  syncStart,
  syncSuccess,
} from '@zonofi/zono-money-store';
import { offlineQueue } from './offline-queue';

const offlineQueueInstance = offlineQueue;

export const hydrateOfflineQueue = async () => {
  await offlineQueueInstance.hydrate();
};

export const syncOfflineQueue = async () => {
  dispatch(syncStart());

  try {
    await hydrateOfflineQueue();
    await offlineQueueInstance.sync();

    dispatch(syncSuccess());

    return { success: true, error: null };
  } catch (e: any) {
    await hydrateOfflineQueue();

    const errorMessage =
      e?.message ?? e?.data?.message ?? 'Something went wrong during sync!!!';

    dispatch(syncError(errorMessage));

    return { success: false, error: errorMessage };
  }
};
